import type * as React from 'react';

import { Link, NavLink } from 'react-router-dom';
import { css } from 'react-strict-dom';

type LinkProps = React.ComponentProps<typeof Link>;
type NavLinkProps = React.ComponentProps<typeof NavLink>;

/**
 * Internal navigation links. react-router handles the client-side routing and
 * the RSD class removes the browser's default underline, so internal links are
 * styled without a global anchor reset.
 */
export function RouterLink({ className, ...props }: LinkProps) {
  return <Link {...props} className={mergeClass(className)} />;
}

export function RouterNavLink({ className, ...props }: NavLinkProps) {
  return (
    <NavLink
      {...props}
      className={
        typeof className === 'function'
          ? (state) => mergeClass(className(state))
          : mergeClass(className)
      }
    />
  );
}

function mergeClass(className: string | undefined): string {
  return [className, css.props(styles.link).className]
    .filter(Boolean)
    .join(' ');
}

const styles = css.create({
  link: {
    color: 'inherit',
    textDecorationLine: 'none',
  },
});
